import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';
import { MatDialog } from '@angular/material/dialog';
import { routingConstants } from '../../_constants/routing-constants.const';
import { WorkflowService } from '../../_services/workflow.service';
import { GenericModalUtil } from '../../_helpers/generic-modal.util';
import { AccessService } from '../../_services/access.service';

@Component({
  selector: 'app-top-bar',
  imports: [TranslatePipe, RouterLink],
  templateUrl: './top-bar.html',
  styleUrl: './top-bar.scss',
})
export class TopBar implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(MsalService);
  private readonly dialog = inject(MatDialog);
  private readonly translateService = inject(TranslateService);
  private readonly workflowService = inject(WorkflowService);
  private readonly accessService = inject(AccessService);

  // Beheer link: Entra Manager role, and user management set up for this tenant.
  public showManage(): boolean {
    const me = this.accessService.me();
    return !!me?.isManager && me.enabled;
  }

  public signedInUser(): string | undefined {
    return this.authService.instance.getAllAccounts().map((account) => account.name)[0];
  }

  public ngOnInit(): void {
    window.addEventListener('beforeunload', (event) => {
      if (this.workflowService.isStepInProgress()) {
        event.preventDefault();
        return false;
      }
      return true;
    });
  }

  public redirectToDashboard(): void {
    this.handleWorkflowInProgress(() => {
      this.router.navigate([routingConstants.transcriber]);
    });
  }

  public openManager(): void {
    const navigate = () => this.router.navigate([routingConstants.manager]);
    if (this.workflowService.isStepInProgress()) {
      this.openLeaveWorkflowDialog(navigate);
    } else {
      navigate();
    }
  }

  public logout(): void {
    if (this.workflowService.isStepInProgress()) {
      this.openLeaveWorkflowDialog(() => this.performLogout());
    } else {
      this.performLogout();
    }
  }

  private handleWorkflowInProgress(onConfirm: () => void): void {
    if (this.workflowService.isStepInProgress()) {
      this.openLeaveWorkflowDialog(() => window.location.reload());
    } else {
      onConfirm();
      window.location.reload();
    }
  }

  private openLeaveWorkflowDialog(onConfirm: () => void): void {
    const confirmDialogRef = GenericModalUtil.openConfirmActionDialog(
      this.translateService,
      this.dialog,
      'dialog.leaveWorkflowQuestion',
    );

    confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.workflowService.setStepInProgress(false);
        onConfirm();
      }
    });
  }

  private performLogout(): void {
    this.authService.logoutRedirect({
      postLogoutRedirectUri: location.origin + '/' + routingConstants.login,
    });
  }
}
